/**
 * FAQ accordion: at most one panel open; clicking the open item closes all.
 */
(() => {
  const accordion = document.querySelector("[data-faq-accordion]");
  if (!accordion) {
    return;
  }

  const items = Array.from(accordion.querySelectorAll(".faq__item"));

  const closeAll = () => {
    items.forEach((item) => {
      const btn = item.querySelector(".faq__trigger");
      const panel = item.querySelector(".faq__panel");
      if (!btn || !panel) {
        return;
      }
      btn.setAttribute("aria-expanded", "false");
      panel.hidden = true;
    });
  };

  items.forEach((item) => {
    const btn = item.querySelector(".faq__trigger");
    const panel = item.querySelector(".faq__panel");
    if (!btn || !panel) {
      return;
    }

    btn.addEventListener("click", () => {
      const wasOpen = btn.getAttribute("aria-expanded") === "true";
      closeAll();
      if (!wasOpen) {
        btn.setAttribute("aria-expanded", "true");
        panel.hidden = false;
      }
    });
  });
})();

(() => {
  const root = document.querySelector("#companies-splide");
  if (!root || typeof Splide === "undefined") {
    return;
  }

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  const extensionPack =
    typeof window !== "undefined" &&
    window.splide &&
    window.splide.Extensions
      ? window.splide.Extensions
      : {};

  const splide = new Splide(root, {
    type: "loop",
    drag: "free",
    arrows: false,
    pagination: false,
    gap: "1.125rem",
    autoWidth: true,
    focus: "center",
    omitEnd: true,
    speed: 600,
    easing: "cubic-bezier(0.33, 1, 0.68, 1)",
    autoScroll: prefersReducedMotion
      ? false
      : {
          speed: 0.72,
          pauseOnHover: true,
          pauseOnFocus: true,
        },
  });

  if (prefersReducedMotion || !extensionPack.AutoScroll) {
    splide.mount();
    return;
  }

  splide.mount(extensionPack);
})();
